import Image from "next/image";
import Link from "next/link";

import { Button } from "components/Button";
import { useTranslationContext } from "context/translation";
import { FC } from "react";
import st from "./featured-product.module.scss";

export interface FeaturedProductProps {
  heroUrl: string;
  beforeImageText: string;
  afterImageText: string;
  direction: "row" | "column";
  productLink: string;
}

const FeaturedProduct: FC<FeaturedProductProps> = ({
  beforeImageText,
  heroUrl,
  afterImageText,
  direction,
  productLink,
}) => {
  const { shopNow = "Shop now" } = useTranslationContext();

  return direction === "row" ? (
    <div className={st.container} style={{ flexDirection: "row" }}>
      <Image
        src={heroUrl}
        alt="featured product hero"
        className={st.productImage}
        style={{ width: "40%" }}
        width={0}
        height={0}
        sizes="100vw"
      />
      <div className={st.columnContainer} style={{ width: "100%" }}>
        {beforeImageText && <div className={st.header}>{beforeImageText}</div>}
        {afterImageText && (
          <div className={st.description}>{afterImageText}</div>
        )}
        <Link href={productLink}>
          <Button>{shopNow}</Button>
        </Link>
      </div>
    </div>
  ) : (
    <div className={st.container} style={{ flexDirection: "column" }}>
      {beforeImageText && <div className={st.header}>{beforeImageText}</div>}
      <Image
        src={heroUrl}
        alt="featured product hero"
        className={st.productImage}
        width={0}
        height={0}
        sizes="100vw"
      />
      {afterImageText && <div className={st.description}>{afterImageText}</div>}
      <Link href={productLink}>
        <Button>{shopNow}</Button>
      </Link>
    </div>
  );
};

export default FeaturedProduct;
